import type { FC } from 'react';

import { useDeviceType } from '@packages/shared';

import { usePaging } from '../../hooks/usePaging';
import { useDisplayMode } from '../../hooks/useDisplayMode';
import { useSorting } from '../../hooks/useSorting';
import type { ApiDisplayType, SortingOrder } from '../../api/rest/types';

import { DisplaySettingsMobile } from '../DisplaySettingsMobile';
import { DisplaySettingsDesktop } from '../DisplaySettingsDesktop';

export type DisplaySettingsProps = {
  availableSortingOrders: SortingOrder[];
  apiDisplayType?: ApiDisplayType;
  pageCount: number;
};

/**
 * Responsive component to change display settings
 * */
export const DisplaySettings: FC<DisplaySettingsProps> = ({
  availableSortingOrders,
  apiDisplayType,
  pageCount,
}) => {
  const { isDesktop } = useDeviceType();
  const { sortingKey, pushSortingChange } = useSorting(availableSortingOrders);
  const { pushPagingMode, pagingMode } = usePaging();
  const { displayMode, pushDisplayModeChange } = useDisplayMode(apiDisplayType);

  return isDesktop ? (
    <DisplaySettingsDesktop
      pageCount={pageCount}
      pagingMode={pagingMode}
      onChangePagingMode={pushPagingMode}
      sortingOptions={availableSortingOrders}
      sortingKey={sortingKey}
      onChangeSortingKey={pushSortingChange}
      displayMode={displayMode}
      onChangeDisplayMode={pushDisplayModeChange}
    />
  ) : (
    <DisplaySettingsMobile
      pagingMode={pagingMode}
      // actually `displayMode` is already accounting for device, but typescript cannot infer that
      displayMode={displayMode === 'largeCards' ? 'cards' : displayMode}
      onChangeDisplayMode={pushDisplayModeChange}
    />
  );
};
